import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';
import { getPartnerApisHeaders } from "./partnerApisHeaders";

/* Get list of apps for a Partner */
export const getPartnerSpecificApps = (mpacBaseUrl, partnerId, queryParams) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/vendor/").concat(partnerId, "?").concat(queryString.stringify(queryParams)), {
  headers: getPartnerApisHeaders()
}).then(response => response.json());
const routeToApiMapping = {
  sales: 'transaction',
  evaluations: 'license',
  feedback: 'feedback',
  conversions: 'cloud-trend',
  renewals: 'cloud-trend',
  churn: 'cloud-trend',
  transactions: 'transaction',
  licenses: 'license',
  'feedback-details': 'feedback'
};
/* Get list of apps for a applicable for a given Report & Partner */

export const getAppsOfAReport = (mpacBaseUrl, partnerId, reportName) => {
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/vendor/rest/2/vendors/").concat(partnerId, "/reporting/apps?reportType=").concat(routeToApiMapping[reportName]), {
    headers: getPartnerApisHeaders()
  }).then(response => response.json()).then(response => response.apps.map(app => ({
    label: app.appName,
    value: app.appKey,
    appId: app.appId
  })));
};